import JustifyContent from "autoprefixer/lib/hacks/justify-content";
import React,{useState, useEffect} from "react";

export default function MainImage(){

  const mainContainerStyle = {
    width: '100%',
    display: 'flex',
    height: '500px',
  }
  const imageStyle = {
      width: '100%',
      objectFit: 'cover',
      filter: 'grayscale(80%) blur(5px)'
  }

  return(
      <>
              {/* <div style={textStyle}>
                <div style={firstTextFontStyle}><span>THE BEST</span></div>
                <div ><span style={secondTextFontStyle}>FOR EVERY OCATION.</span></div>
             </div> */}
          <div style={mainContainerStyle}>
              <img style={imageStyle} src="/resources/landFarmed.jpg"></img>
          </div>
      </>
  )
    // Css
    // const slideshowContainerStyle ={
    //   height: "32em",
    //   width: "100%",
    //   display: "flex",
    //   gridTemplateColumns: "40% 40% 20%",
    //   gridTemplateRows: "50% 50%",
    //   position:""
    // }

    // const textStyle={
    //   color: "#F0EFEC",
    //   textAlign: "left",
    //   gridColumnStart: "1",
    //   gridColumnEnd: "3",
    //   gridRowStart: "2",
    //   zIndex: "10",
    //   display:"flex",
    //   flexDirection:"column",
    //   justifyContent:"flex-end",
    //   padding:"0 0 0 14rem"
    //   }

    // const corouselImagesStyle = {
    //   height: "100%", 
    //   width:"100%",
    //   objectFit: "cover",
    //   filter: 'grayscale(70%) blur(3px)'
      
    //   }

    // const carouselContainerStyle = {
    //   gridColumnStart: "1",
    //   gridColumnEnd: "4",
    //   gridRowStart: "1",
    //   gridRowEnd: "3"
    // }

    // #region Fonts
    // const firstTextFontStyle = {
    //   fontFamily: 'Oswald',
    //   fontStyle: 'Bold',
    //   color: '#F0EFEC',
    //   fontSize:"70px",
    //   justifyContent:"left"
 
    // }

    // const secondTextFontStyle = {
    //   fontFamily: 'Oswald',
    //   fontSize:"50px",
    //   fontStyle: 'Bold',
    //   color: "#011a39",
    //   backgroundColor:"#F0EFEC",
    //   padding:"20px 5px",
    //   background: "linear-gradient(70deg, #F0EFEC 12ch, rgb(255,255,255,.01) 12.05ch)"

    // }

    // #endregion
      
    // Display
    // return(
    //     <>
    //       <div style={slideshowContainerStyle}>

    //          <div style={carouselContainerStyle} className="image fade">
    //            <img src={'/resources/landFarmed.jpg'} style={corouselImagesStyle}/>
    //          </div>


    //         <div style={textStyle}>
    //           <div style={firstTextFontStyle}><span>THE BEST</span></div>
    //           <div ><span style={secondTextFontStyle}>FOR EVERY OCATION.</span></div>
    //         </div>

    //       </div>   

    //     </>
       
    // )
}